import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { company, DEFAULT_COMPANIES } from '~/company/Company';
import Counter from '~/components/Counter';
import Price from '~/components/Price';
import { pluralizePcLabel } from '~/components/ProductCard/utils';
import { UI_BOTTOM_COMPONENTS } from '~/constants/variables';
import { Offer } from '~/stores/CategoriesStore';
import { convertPenceToPounds, formatPrice } from '~/utils/formaters';

import '../styles.scss';
import styles from '../Product.module.scss';

type Props = {
  offer?: Offer;
  isMultiBuy?: boolean;
  currentPrice?: string;
  oldPrice: string | null;
  count: number;
  limit: number;

  handleChangeCount: (count: number, action: 'add' | 'remove') => void;
};

const MobileBottomContainerLocalee = forwardRef<HTMLDivElement, Props>(
  (
    {
      offer,
      isMultiBuy,
      currentPrice,
      oldPrice,
      count,
      limit,
      handleChangeCount,
    },
    ref,
  ) => {
    const { t } = useTranslation();

    if (!offer) {
      return null;
    }

    const componentBody = () => {
      if (DEFAULT_COMPANIES.includes(company.name)) {
        return (
          <div
            className="mobile-bottom-button-container _h"
            data-company={company.name}
            id={UI_BOTTOM_COMPONENTS.CTA}
          >
            {count > 0 ? (
              <Counter
                size="m"
                count={count}
                onClick={handleChangeCount}
                limit={limit}
              />
            ) : (
              <button
                data-button="add-to-cart"
                type="button"
                className={classes([
                  'button _primary _med',
                  limit === 0 && '_disabled',
                ])}
                onClick={() => handleChangeCount(count + 1, 'add')}
              >
                {limit > 0 ? t('addToCart') : t('soldOut')}
              </button>
            )}
          </div>
        );
      } else {
        return (
          <div
            ref={ref}
            className="mobile-bottom-button-container _h"
            data-company={company.name}
            id={UI_BOTTOM_COMPONENTS.CTA}
          >
            <div>
              {isMultiBuy && (
                <div className={styles.multiBuyFromRule}>
                  {t('phrases:fromPc', {
                    length: pluralizePcLabel(
                      offer.getLowestMultibuyLevel()?.quantity,
                    ),
                  })}
                </div>
              )}
              <Price
                price={
                  isMultiBuy
                    ? convertPenceToPounds(
                        offer.getLowestMultibuyLevel()?.unitPrice ?? 0,
                      )
                    : (currentPrice ?? '')
                }
                discount={isMultiBuy ? '' : (oldPrice ?? '')}
                classNameCurrentPrice={
                  isMultiBuy ? styles.multiBuyMobileCurrentPrice : undefined
                }
              />
              {isMultiBuy && (
                <div className={styles.multiBuyActualPrice}>
                  {'\uf101'} {formatPrice(currentPrice ?? 0)}&nbsp;/&nbsp;
                  {company.config.defaultVolumeDisplay}
                </div>
              )}
            </div>
            {count > 0 ? (
              <Counter
                size="m"
                count={count}
                onClick={handleChangeCount}
                limit={limit}
              />
            ) : (
              <button
                data-button="add-to-cart"
                type="button"
                className={classes([
                  'button _primary _med',
                  limit === 0 && '_disabled',
                ])}
                onClick={() => handleChangeCount(count + 1, 'add')}
              >
                {limit > 0 ? t('addToCart') : t('soldOut')}
              </button>
            )}
          </div>
        );
      }
    };

    return componentBody();
  },
);

MobileBottomContainerLocalee.displayName = 'MobileBottomContainerLocalee';

export default observer(MobileBottomContainerLocalee);
